import { TResult } from "../../resources"

type ResultsProps = {
    results: Array<TResult>
}

export const Results = ({ results }: ResultsProps) => {
    return (
        <>
            <div className="table-results">
                <div className="table-results__header">
                    <div className="table-results__header__collumn-first">Pořadí</div>
                    <div className="table-results__header__collumn-second">Jméno týmu</div>
                    <div className="table-results__header__collumn-third">Celkový čas</div>
                </div>
                {results.map((r: TResult) =>
                    <div key={r.name} className="table-results__row">
                        <div className="table-results__row__collumn-first">{r.order}.</div>
                        <div className="table-results__row__collumn-second">{r.name}</div>
                        <div className="table-results__row__collumn-third">{r.time}</div>
                    </div>)
                }
            </div>
        </>
    )
}